import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingFichaDiariaProvider,
  useRankingFichaDiaria,
} from "./context/RankingFichaDiariaContext";
import { RankingFichaDiariaView } from "./components/RankingFichaDiariaView";

const RankingFichaDiariaContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    usuarios,
    dailyStats,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    dateLabel,
    selectedLojaNome,
    criterio,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
  } = useRankingFichaDiaria();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-red-900 text-white">
        <div className="text-center">
          <p className="text-xl">Carregando ranking...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingFichaDiariaView
      usuarios={usuarios}
      dailyStats={dailyStats}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      dateLabel={dateLabel}
      selectedLojaNome={selectedLojaNome}
      criterio={criterio}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RankingFichaDiariaPage: React.FC = () => {
  return (
    <RankingFichaDiariaProvider>
      <RankingFichaDiariaContent />
    </RankingFichaDiariaProvider>
  );
};

export default RankingFichaDiariaPage;
